import React, { useMemo } from 'react'

// Hooks
import { useListingDisplay } from '../../hooks/listing'
import { useLoading } from '../../hooks/loading'
import { useIsOwner } from '../../hooks/branding'

// Constants
import {
  POSSIBLE_GAIN,
  POSSIBLE_LOSS,
  POSSIBLY_SAVE,
  POSSIBLY_LOSE,
  OVER_BUDGET,
  UNDER_BUDGET,
} from '../../constants/indicators'
import { useBuyerSettings } from '../../hooks/buyerSettings'

const withContainer = WrappedComponent => props => {
  const {
    budgetDiff,
    color,
    savingsValue,
    text: statusText,
    totalBuyCost,
  } = useListingDisplay()

  const { hasUpdatedListingsBotProfile } = useBuyerSettings()

  const { settledRequest } = useLoading()

  const isOwner = useIsOwner()

  const text = useMemo(() => {
    if (hasUpdatedListingsBotProfile) {
      return `${statusText} buy`
    } else {
      return 'Gain insights'
    }
  }, [statusText, hasUpdatedListingsBotProfile])

  const overUnderBudget = useMemo(
    () => (budgetDiff >= 0 ? OVER_BUDGET : UNDER_BUDGET),
    [budgetDiff]
  )

  const gainOrLoss = useMemo(() => {
    if (isOwner) {
      return totalBuyCost < 0 ? POSSIBLE_GAIN : POSSIBLE_LOSS
    } else {
      return savingsValue > 0 ? POSSIBLY_SAVE : POSSIBLY_LOSE
    }
  }, [savingsValue, totalBuyCost, isOwner])

  const subText = useMemo(() => {
    if (!hasUpdatedListingsBotProfile) return null

    return `${overUnderBudget}  •  ${gainOrLoss}`
  }, [hasUpdatedListingsBotProfile, overUnderBudget, gainOrLoss])

  const colorWithPinkFallBack = useMemo(() => {
    if (!hasUpdatedListingsBotProfile) {
      return 'pink'
    }

    return color
  }, [hasUpdatedListingsBotProfile, color])

  return (
    <WrappedComponent
      {...props}
      text={text}
      subText={subText}
      color={colorWithPinkFallBack}
      thinking={!settledRequest}
    />
  )
}

export default withContainer
